(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chicchok-series-page-native"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pageCache = new Map();
    const pageRequests = new Map();
    const groupStates = new WeakMap();
    const initializedGalleries = new WeakSet();
    const sectionObservers = new WeakMap();
    const prefetchSchedulers = new WeakMap();
    const transitionDuration = 110;
    const requestTimeout = 15000;
    const prefetchTimeout = 20000;
    const prefetchMaxAttempts = 2;
    const sessionCachePrefix = 'chicchok-series-pages-v3';
    const sessionCacheTtl = 30 * 60 * 1000;

    const wait = duration => new Promise(resolve => window.setTimeout(resolve, duration));
    const nextFrame = () => new Promise(resolve => window.requestAnimationFrame(() => window.requestAnimationFrame(resolve)));
    const restoreScroll = position => {
      const previousScrollBehavior = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo(position.left, position.top);
      document.documentElement.style.scrollBehavior = previousScrollBehavior;
    };

    const activateGalleryImage = (mediaItem, eager = false) => {
      const image = mediaItem?.querySelector('img');

      if (!image) {
        return;
      }

      if (eager) {
        image.loading = 'eager';
        image.fetchPriority = 'high';
      }

      if (image.dataset.srcset) {
        image.srcset = image.dataset.srcset;
        delete image.dataset.srcset;
      }

      if (image.dataset.src) {
        image.src = image.dataset.src;
        delete image.dataset.src;
      }
    };

    const updateGallery = (gallery, nextIndex, eager = false) => {
      const mediaItems = Array.from(gallery.querySelectorAll('[data-native-series-media]'));

      if (mediaItems.length < 2) {
        return;
      }

      const index = Math.max(0, Math.min(nextIndex, mediaItems.length - 1));
      const previousButton = gallery.querySelector('[data-native-series-media-prev]');
      const nextButton = gallery.querySelector('[data-native-series-media-next]');
      const status = gallery.querySelector('[data-native-series-media-status]');
      const controlIndex = gallery.dataset.nativeSeriesHoverOrigin === undefined
        ? index
        : Number(gallery.dataset.nativeSeriesHoverOrigin || 0);

      gallery.dataset.nativeSeriesMediaIndex = String(index);
      activateGalleryImage(mediaItems[index], eager);

      mediaItems.forEach((mediaItem, mediaIndex) => {
        const isActive = mediaIndex === index;
        mediaItem.classList.toggle('is-active', isActive);
        mediaItem.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      if (previousButton) {
        previousButton.disabled = controlIndex === 0;
        previousButton.setAttribute('aria-disabled', controlIndex === 0 ? 'true' : 'false');
      }

      if (nextButton) {
        nextButton.disabled = controlIndex === mediaItems.length - 1;
        nextButton.setAttribute('aria-disabled', controlIndex === mediaItems.length - 1 ? 'true' : 'false');
      }

      if (previousButton && document.activeElement === previousButton && previousButton.disabled && nextButton && !nextButton.disabled) {
        nextButton.focus({ preventScroll: true });
      }

      if (nextButton && document.activeElement === nextButton && nextButton.disabled && previousButton && !previousButton.disabled) {
        previousButton.focus({ preventScroll: true });
      }

      if (status) {
        status.textContent = `${index + 1} / ${mediaItems.length}`;
      }
    };

    const moveGallery = (gallery, direction) => {
      const currentIndex = gallery.dataset.nativeSeriesHoverOrigin === undefined
        ? Number(gallery.dataset.nativeSeriesMediaIndex || 0)
        : Number(gallery.dataset.nativeSeriesHoverOrigin || 0);

      delete gallery.dataset.nativeSeriesHoverOrigin;
      gallery.classList.remove('is-hover-preview');
      updateGallery(gallery, currentIndex + direction, true);
    };

    const initGallery = gallery => {
      if (initializedGalleries.has(gallery)) {
        return;
      }

      initializedGalleries.add(gallery);
      gallery.dataset.nativeSeriesMediaIndex = '0';
      updateGallery(gallery, 0);

      const supportsHoverPreview = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      if (supportsHoverPreview) {
        gallery.addEventListener('mouseenter', () => {
          const mediaItems = Array.from(gallery.querySelectorAll('[data-native-series-media]'));

          if (mediaItems.length < 2 || gallery.dataset.nativeSeriesHoverOrigin !== undefined) {
            return;
          }

          const currentIndex = Number(gallery.dataset.nativeSeriesMediaIndex || 0);
          const previewIndex = currentIndex < mediaItems.length - 1 ? currentIndex + 1 : currentIndex - 1;
          gallery.dataset.nativeSeriesHoverOrigin = String(currentIndex);
          gallery.classList.add('is-hover-preview');
          updateGallery(gallery, previewIndex, true);
        });

        gallery.addEventListener('mouseleave', () => {
          if (gallery.dataset.nativeSeriesHoverOrigin === undefined) {
            return;
          }

          const originIndex = Number(gallery.dataset.nativeSeriesHoverOrigin || 0);

          delete gallery.dataset.nativeSeriesHoverOrigin;
          gallery.classList.remove('is-hover-preview');
          updateGallery(gallery, originIndex);
        });
      }

      gallery.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          moveGallery(gallery, -1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          moveGallery(gallery, 1);
        }
      });

      let pointerStart = null;
      let touchStart = null;

      const handleSwipe = (deltaX, deltaY) => {
        if (Math.abs(deltaX) < 38 || Math.abs(deltaX) <= Math.abs(deltaY)) {
          return;
        }

        gallery.dataset.nativeSeriesSuppressClick = 'true';
        moveGallery(gallery, deltaX < 0 ? 1 : -1);

        window.setTimeout(() => {
          delete gallery.dataset.nativeSeriesSuppressClick;
        }, 0);
      };

      gallery.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch' || event.button !== 0 || event.target.closest('[data-native-series-media-prev], [data-native-series-media-next]')) {
          return;
        }

        pointerStart = {
          x: event.clientX,
          y: event.clientY,
          id: event.pointerId
        };
      });

      gallery.addEventListener('pointermove', event => {
        if (event.pointerType === 'touch' || !pointerStart || pointerStart.id !== event.pointerId) {
          return;
        }

        const deltaX = event.clientX - pointerStart.x;
        const deltaY = event.clientY - pointerStart.y;

        if (
          Math.abs(deltaX) >= 38
          && Math.abs(deltaX) > Math.abs(deltaY)
          && gallery.setPointerCapture
          && (!gallery.hasPointerCapture || !gallery.hasPointerCapture(event.pointerId))
        ) {
          gallery.setPointerCapture(event.pointerId);
        }
      });

      gallery.addEventListener('pointerup', event => {
        if (event.pointerType === 'touch' || !pointerStart || pointerStart.id !== event.pointerId) {
          return;
        }

        const deltaX = event.clientX - pointerStart.x;
        const deltaY = event.clientY - pointerStart.y;

        if (gallery.hasPointerCapture && gallery.hasPointerCapture(event.pointerId)) {
          gallery.releasePointerCapture(event.pointerId);
        }

        pointerStart = null;
        handleSwipe(deltaX, deltaY);
      });

      gallery.addEventListener('pointercancel', () => {
        pointerStart = null;
      });

      gallery.addEventListener('touchstart', event => {
        const touch = event.touches[0];

        if (!touch || event.target.closest('[data-native-series-media-prev], [data-native-series-media-next]')) {
          return;
        }

        touchStart = {
          x: touch.clientX,
          y: touch.clientY
        };
      }, { passive: true });

      gallery.addEventListener('touchmove', event => {
        const touch = event.touches[0];

        if (!touchStart || !touch) {
          return;
        }

        const deltaX = touch.clientX - touchStart.x;
        const deltaY = touch.clientY - touchStart.y;

        if (Math.abs(deltaX) < 38 || Math.abs(deltaX) <= Math.abs(deltaY)) {
          return;
        }

        touchStart = null;
        handleSwipe(deltaX, deltaY);
      }, { passive: true });

      gallery.addEventListener('touchend', event => {
        const touch = event.changedTouches[0];

        if (!touchStart || !touch) {
          return;
        }

        const deltaX = touch.clientX - touchStart.x;
        const deltaY = touch.clientY - touchStart.y;
        touchStart = null;
        handleSwipe(deltaX, deltaY);
      }, { passive: true });

      gallery.addEventListener('touchcancel', () => {
        touchStart = null;
      }, { passive: true });

      const mediaLink = gallery.querySelector('.chicchok-series-page-native__product-media');

      if (mediaLink) {
        mediaLink.addEventListener('click', event => {
          if (gallery.dataset.nativeSeriesSuppressClick === 'true') {
            event.preventDefault();
          }
        });
      }
    };

    const initReveal = section => {
      const revealItems = Array.from(section.querySelectorAll('[data-native-series-reveal]'));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const existingObserver = sectionObservers.get(section);

      if (existingObserver) {
        existingObserver.disconnect();
        sectionObservers.delete(section);
      }

      section.classList.add('is-native-series-ready');

      if (reducedMotion || !('IntersectionObserver' in window)) {
        revealItems.forEach(item => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, {
        threshold: .08,
        rootMargin: '0px 0px -6% 0px'
      });

      sectionObservers.set(section, observer);
      revealItems.forEach(item => observer.observe(item));
    };

    const getGroupState = group => {
      let state = groupStates.get(group);

      if (!state) {
        state = {
          controller: null,
          requestId: 0
        };
        groupStates.set(group, state);
      }

      return state;
    };

    const getCacheKey = (group, page) => `${group.dataset.collectionUrl}|${page}`;

    const getSessionCacheKey = (group, page) => {
      const section = group.closest('[data-chicchok-series-native]');
      const themeId = section?.dataset.themeId || 'published';
      return `${sessionCachePrefix}:${themeId}:${getCacheKey(group, page)}`;
    };

    const storePagePayload = (group, page, payload) => {
      const cacheKey = getCacheKey(group, page);
      pageCache.set(cacheKey, payload);

      try {
        window.sessionStorage.setItem(getSessionCacheKey(group, page), JSON.stringify({
          cachedAt: Date.now(),
          payload
        }));
      } catch (_error) {
        // Memory caching still works when storage is unavailable or full.
      }
    };

    const getPagePayload = (group, page) => {
      const cacheKey = getCacheKey(group, page);

      if (pageCache.has(cacheKey)) {
        return pageCache.get(cacheKey);
      }

      try {
        const sessionCacheKey = getSessionCacheKey(group, page);
        const cached = JSON.parse(window.sessionStorage.getItem(sessionCacheKey) || 'null');

        if (!cached || Date.now() - Number(cached.cachedAt || 0) > sessionCacheTtl) {
          window.sessionStorage.removeItem(sessionCacheKey);
          return null;
        }

        if (!cached.payload || Number(cached.payload.currentPage) !== Number(page) || typeof cached.payload.html !== 'string') {
          window.sessionStorage.removeItem(sessionCacheKey);
          return null;
        }

        pageCache.set(cacheKey, cached.payload);
        return cached.payload;
      } catch (_error) {
        return null;
      }
    };

    const clearTransitionClasses = content => {
      if (!content) {
        return;
      }

      content.classList.remove(
        'is-page-leaving-next',
        'is-page-leaving-previous',
        'is-page-entering-next',
        'is-page-entering-previous'
      );
    };

    const initDynamicContent = content => {
      content.querySelectorAll('[data-native-series-gallery]').forEach(initGallery);
      content.querySelectorAll('[data-native-series-reveal]').forEach(item => {
        item.classList.add('is-visible');
        item.removeAttribute('data-native-series-reveal');
      });
    };

    const setPaginationStatus = (group, text, isError = false) => {
      const status = group.querySelector('[data-native-series-pagination-status]');

      if (!status) {
        return;
      }

      status.textContent = text;
      status.classList.toggle('is-error', isError);
    };

    const buildSectionRequestUrl = (group, page) => {
      const requestUrl = new URL(group.dataset.collectionUrl, window.location.origin);
      const section = group.closest('[data-chicchok-series-native]');
      const urlPreviewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
      const previewThemeId = urlPreviewThemeId || (section?.dataset.themeRole === 'unpublished' ? section.dataset.themeId : '');

      requestUrl.searchParams.set('section_id', 'chicchok-series-product-group');
      requestUrl.searchParams.set('page', String(page));

      if (previewThemeId) {
        requestUrl.searchParams.set('preview_theme_id', previewThemeId);
      }

      return requestUrl;
    };

    const fetchWithTransientRetry = async (url, options, maxRetries = 1) => {
      for (let attempt = 0; attempt <= maxRetries; attempt += 1) {
        try {
          const response = await fetch(url, options);
          const isTransient = response.status === 429 || response.status >= 500;

          if (response.ok || !isTransient || attempt === maxRetries) {
            return response;
          }
        } catch (error) {
          if (error.name === 'AbortError' || attempt === maxRetries) {
            throw error;
          }
        }

        await wait(400 * (attempt + 1));
      }

      throw new Error('Series group request retry failed');
    };

    const parseGroupPayload = (html, group) => {
      if (!html.trim()) {
        throw new Error('Empty series group response');
      }

      const template = document.createElement('template');
      template.innerHTML = html;
      const fragment = template.content.querySelector('[data-chicchok-series-group-fragment]');
      const content = fragment && fragment.querySelector('[data-native-series-group-content]');

      if (!fragment || !content || fragment.dataset.seriesGroup !== group.dataset.seriesGroup) {
        throw new Error('Invalid series group response');
      }

      return {
        currentPage: Number(fragment.dataset.currentPage || 1),
        html: content.innerHTML
      };
    };

    const fetchPrefetchedPayload = (group, page) => {
      const cacheKey = getCacheKey(group, page);

      const cachedPayload = getPagePayload(group, page);

      if (cachedPayload) {
        return Promise.resolve(cachedPayload);
      }

      if (pageRequests.has(cacheKey)) {
        return pageRequests.get(cacheKey).promise;
      }

      const controller = new AbortController();
      let timeoutId = null;
      const request = {
        controller,
        userConsumers: 0,
        promise: null
      };

      request.promise = (async () => {
        timeoutId = window.setTimeout(() => controller.abort(), prefetchTimeout);

        try {
          const response = await fetchWithTransientRetry(buildSectionRequestUrl(group, page), {
            credentials: 'same-origin',
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            },
            priority: 'low',
            signal: controller.signal
          });

          if (!response.ok) {
            return null;
          }

          const payload = parseGroupPayload(await response.text(), group);
          if (Number(payload.currentPage) !== Number(page)) {
            throw new Error('Unexpected series group page response');
          }
          storePagePayload(group, page, payload);
          const prefetchedPages = new Set((group.dataset.nativeSeriesPrefetchedPages || '').split(',').filter(Boolean));
          prefetchedPages.add(String(page));
          group.dataset.nativeSeriesPrefetchedPages = Array.from(prefetchedPages).sort((left, right) => Number(left) - Number(right)).join(',');

          if (!group.dataset.nativeSeriesPrefetchedPage) {
            group.dataset.nativeSeriesPrefetchedPage = String(page);
          }

          return payload;
        } catch (_error) {
          return null;
        } finally {
          window.clearTimeout(timeoutId);
          if (pageRequests.get(cacheKey) === request) {
            pageRequests.delete(cacheKey);
          }
        }
      })();

      pageRequests.set(cacheKey, request);
      return request.promise;
    };

    const updatePrefetchState = scheduler => {
      const remaining = scheduler.queue.length + scheduler.active;
      scheduler.section.dataset.nativeSeriesPrefetchCompleted = String(scheduler.completed);

      if (scheduler.networkDisabled) {
        scheduler.section.dataset.nativeSeriesPrefetchState = 'disabled-network';
      } else if (document.hidden) {
        scheduler.section.dataset.nativeSeriesPrefetchState = 'hidden';
      } else if (scheduler.cartPaused || scheduler.cartWaiting || scheduler.userRequests > 0) {
        scheduler.section.dataset.nativeSeriesPrefetchState = 'paused';
      } else if (!scheduler.started) {
        scheduler.section.dataset.nativeSeriesPrefetchState = 'waiting';
      } else if (remaining > 0) {
        scheduler.section.dataset.nativeSeriesPrefetchState = scheduler.userRequests > 0 ? 'paused' : 'loading';
      } else {
        scheduler.section.dataset.nativeSeriesPrefetchState = scheduler.failed > 0 ? 'partial' : 'complete';
      }
    };

    const isDesiredPrefetchTask = (scheduler, task) => !scheduler.stopped &&
      task.group.isConnected && getCacheKey(task.group, task.page) === scheduler.desiredKey;

    const abortBackgroundPrefetch = scheduler => {
      scheduler.activeTasks.forEach((task, cacheKey) => {
        const request = pageRequests.get(cacheKey);

        if (request && request.userConsumers === 0) {
          task.paused = true;
          request.controller.abort();
        }
      });
    };

    const waitForPrefetchCart = scheduler => {
      const token = ++scheduler.cartWaitToken;
      scheduler.cartWaiting = true;
      scheduler.cartReady = false;
      updatePrefetchState(scheduler);

      Promise.resolve()
        .then(() => window.CHICCHOK_CART_FLOW?.waitForMutations?.())
        .then(() => {
          if (scheduler.stopped || token !== scheduler.cartWaitToken) {
            return;
          }

          scheduler.cartWaiting = false;
          scheduler.cartPaused = window.CHICCHOK_CART_FLOW?.isCheckoutLocked?.() === true;
          scheduler.cartReady = !scheduler.cartPaused;
          updatePrefetchState(scheduler);
          pumpPrefetchQueue(scheduler);
        })
        .catch(() => {
          if (!scheduler.stopped && token === scheduler.cartWaitToken) {
            scheduler.cartWaiting = false;
            scheduler.cartPaused = true;
            updatePrefetchState(scheduler);
          }
        });
    };

    const refreshDesiredPrefetch = scheduler => {
      const group = scheduler.currentGroup;
      const page = group ? Number(group.dataset.currentPage || 1) + 1 : 0;
      scheduler.desiredKey = group && group.isConnected &&
        page <= Number(group.dataset.totalPages || 1) ? getCacheKey(group, page) : '';
      scheduler.queue = scheduler.queue.filter(task => isDesiredPrefetchTask(scheduler, task));
      scheduler.activeTasks.forEach((task, cacheKey) => {
        const request = pageRequests.get(cacheKey);

        if (!isDesiredPrefetchTask(scheduler, task) && request && request.userConsumers === 0) {
          request.controller.abort();
        }
      });

      if (scheduler.desiredKey && !scheduler.exhaustedKeys.has(scheduler.desiredKey) &&
          !getPagePayload(group, page) && !pageRequests.has(scheduler.desiredKey) &&
          !scheduler.activeTasks.has(scheduler.desiredKey) &&
          !scheduler.queue.some(task => getCacheKey(task.group, task.page) === scheduler.desiredKey)) {
        scheduler.queue.push({ group, page, attempt: 1 });
      }

      scheduler.section.dataset.nativeSeriesPrefetchTotal = String(
        scheduler.completed + scheduler.failed + scheduler.queue.length + scheduler.active
      );
      updatePrefetchState(scheduler);
      pumpPrefetchQueue(scheduler);
    };

    const selectPrefetchGroup = (scheduler, group, explicit = false) => {
      if (scheduler.stopped || !group) {
        return;
      }

      if (explicit) {
        scheduler.intentGroup = group;
        scheduler.nearGroups.add(group);
      }

      scheduler.currentGroup = group;
      refreshDesiredPrefetch(scheduler);
    };

    const selectVisiblePrefetchGroup = scheduler => {
      if (scheduler.userRequests > 0) {
        return;
      }

      const current = scheduler.nearGroups.has(scheduler.intentGroup) ? scheduler.intentGroup :
        (scheduler.nearGroups.has(scheduler.currentGroup) ? scheduler.currentGroup :
          scheduler.groups.find(group => scheduler.nearGroups.has(group)));

      if (current) {
        selectPrefetchGroup(scheduler, current);
      } else {
        scheduler.currentGroup = null;
        refreshDesiredPrefetch(scheduler);
      }
    };

    const pumpPrefetchQueue = scheduler => {
      if (scheduler.stopped || !scheduler.started || scheduler.userRequests > 0 ||
          scheduler.networkDisabled || document.hidden || scheduler.cartPaused || scheduler.cartWaiting ||
          window.CHICCHOK_CART_FLOW?.isCheckoutLocked?.() === true) {
        updatePrefetchState(scheduler);
        return;
      }

      if (scheduler.active >= scheduler.concurrency || scheduler.queue.length === 0) {
        updatePrefetchState(scheduler);
        return;
      }

      if (!scheduler.cartReady) {
        waitForPrefetchCart(scheduler);
        return;
      }

      scheduler.cartReady = false;

      while (scheduler.active < scheduler.concurrency && scheduler.queue.length > 0) {
        const task = scheduler.queue.shift();
        const cacheKey = getCacheKey(task.group, task.page);

        if (!isDesiredPrefetchTask(scheduler, task)) {
          continue;
        }

        if (getPagePayload(task.group, task.page) || pageRequests.has(cacheKey)) {
          scheduler.completed += 1;
          continue;
        }

        scheduler.active += 1;
        scheduler.activeTasks.set(cacheKey, task);

        fetchPrefetchedPayload(task.group, task.page)
          .then(payload => {
            if (payload) {
              scheduler.completed += 1;
              return;
            }

            if (!isDesiredPrefetchTask(scheduler, task)) {
              return;
            }

            if ((task.preemptedByUser || task.paused) && !scheduler.stopped) {
              delete task.preemptedByUser;
              delete task.paused;
              scheduler.queue.unshift(task);
              return;
            }

            if (task.attempt < prefetchMaxAttempts && !scheduler.stopped) {
              scheduler.queue.push({ ...task, attempt: task.attempt + 1 });
            } else {
              scheduler.failed += 1;
              scheduler.exhaustedKeys.add(cacheKey);
            }
          })
          .finally(() => {
            scheduler.activeTasks.delete(cacheKey);
            scheduler.active -= 1;
            if (!scheduler.stopped && scheduler.desiredKey !== cacheKey) {
              refreshDesiredPrefetch(scheduler);
            }
            updatePrefetchState(scheduler);
            pumpPrefetchQueue(scheduler);
          });
      }

      updatePrefetchState(scheduler);
    };

    const prioritizeUserRequest = (section, group, page) => {
      const scheduler = prefetchSchedulers.get(section);

      if (!scheduler) {
        return () => {};
      }

      const taskIndex = scheduler.queue.findIndex(task => task.group === group && task.page === page);
      let prioritizedTask = null;

      if (taskIndex >= 0) {
        prioritizedTask = scheduler.queue.splice(taskIndex, 1)[0];
      }

      scheduler.userRequests += 1;
      scheduler.activeTasks.forEach((task, cacheKey) => {
        if (cacheKey === getCacheKey(group, page)) {
          return;
        }

        const request = pageRequests.get(cacheKey);

        if (request && request.userConsumers === 0) {
          task.preemptedByUser = true;
          request.controller.abort();
        }
      });
      updatePrefetchState(scheduler);

      return () => {
        if (prioritizedTask) {
          if (getPagePayload(group, page)) {
            scheduler.completed += 1;
          } else if (isDesiredPrefetchTask(scheduler, prioritizedTask)) {
            scheduler.queue.unshift(prioritizedTask);
          }
        }

        scheduler.userRequests = Math.max(0, scheduler.userRequests - 1);
        if (scheduler.userRequests === 0) {
          selectVisiblePrefetchGroup(scheduler);
        }
        updatePrefetchState(scheduler);
        pumpPrefetchQueue(scheduler);
      };
    };

    const initPagePrefetch = section => {
      if (window.__chicchokDisableSeriesPrefetch === true) {
        section.dataset.nativeSeriesPrefetchState = 'disabled';
        return;
      }

      const groups = Array.from(section.querySelectorAll('[data-native-series-group]'));
      const queue = [];

      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      const scheduler = {
        section,
        groups,
        queue,
        currentGroup: null,
        intentGroup: null,
        desiredKey: '',
        nearGroups: new Set(),
        exhaustedKeys: new Set(),
        active: 0,
        activeTasks: new Map(),
        completed: 0,
        failed: 0,
        userRequests: 0,
        concurrency: 1,
        startDelay: 800,
        started: false,
        stopped: false,
        startTimer: null,
        idleCallbackId: null,
        loadHandler: null,
        observer: null,
        cleanupListeners: [],
        networkDisabled: false,
        cartPaused: false,
        cartWaiting: false,
        cartReady: false,
        cartWaitToken: 0
      };

      prefetchSchedulers.set(section, scheduler);
      section.dataset.nativeSeriesPrefetchTotal = String(queue.length);
      section.dataset.nativeSeriesPrefetchConcurrency = String(scheduler.concurrency);
      const listen = (target, type, handler, options) => {
        target?.addEventListener?.(type, handler, options);
        scheduler.cleanupListeners.push(() => target?.removeEventListener?.(type, handler, options));
      };
      const updateNetwork = () => {
        const effectiveType = connection?.effectiveType || '';
        const saveData = connection?.saveData === true;
        scheduler.networkDisabled = saveData || /(^|-)(2g|3g)$/.test(effectiveType);
        section.dataset.nativeSeriesPrefetchNetwork = saveData ? 'save-data' : (effectiveType || 'unknown');

        if (scheduler.networkDisabled) {
          abortBackgroundPrefetch(scheduler);
        }

        updatePrefetchState(scheduler);
        pumpPrefetchQueue(scheduler);
      };
      const pauseForCart = () => {
        scheduler.cartPaused = true;
        scheduler.cartReady = false;
        abortBackgroundPrefetch(scheduler);
        waitForPrefetchCart(scheduler);
      };
      const resumeForCart = () => waitForPrefetchCart(scheduler);
      listen(connection, 'change', updateNetwork);
      listen(document, 'visibilitychange', () => {
        if (document.hidden) {
          abortBackgroundPrefetch(scheduler);
        } else {
          refreshDesiredPrefetch(scheduler);
        }
        updatePrefetchState(scheduler);
      });
      listen(document, 'chicchok:checkout-state', event => {
        if (event.detail?.locked) {
          pauseForCart();
        } else {
          resumeForCart();
        }
      });
      listen(document, 'line-item-quantity:change:start', pauseForCart);
      ['cart:updated', 'cart:refresh', 'variant:added', 'line-item-quantity:change:end',
        'line-item-quantity:change:error', 'chicchok:cart-resync', 'cart-notification:show']
        .forEach(type => listen(document, type, resumeForCart));
      listen(document, 'submit', event => {
        const form = event.target;
        if (form?.matches?.('form[is="product-form"]') ||
            (form?.tagName === 'FORM' && /\/cart(?:\/add)?(?:\.js)?\/?$/.test(new URL(form.action, window.location.origin).pathname))) {
          pauseForCart();
        }
      }, true);
      listen(document, 'click', event => {
        const target = event.target?.closest?.('[data-chicchok-mobile-submit], [data-chicchok-mobile-action], .form__submit--closer');
        if (target && (!target.matches('.form__submit--closer') ||
            target.closest('openable-element')?.querySelector('textarea[is="cart-note"]'))) {
          pauseForCart();
        }
      }, true);
      listen(document, 'change', event => {
        if (event.target?.matches?.('textarea[is="cart-note"]')) {
          pauseForCart();
        }
      }, true);
      const selectFromIntent = event => {
        const group = event.target?.closest?.('[data-native-series-group]');
        if (group && section.contains(group)) {
          selectPrefetchGroup(scheduler, group, true);
        }
      };
      listen(section, 'pointerdown', selectFromIntent, { passive: true });
      listen(section, 'focusin', selectFromIntent);

      if ('IntersectionObserver' in window) {
        scheduler.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              scheduler.nearGroups.add(entry.target);
            } else {
              scheduler.nearGroups.delete(entry.target);
            }
          });
          selectVisiblePrefetchGroup(scheduler);
        }, { rootMargin: '200px 0px', threshold: 0 });
        groups.forEach(group => scheduler.observer.observe(group));
      }

      updateNetwork();

      const start = () => {
        if (scheduler.stopped || scheduler.started) {
          return;
        }

        const begin = () => {
          scheduler.idleCallbackId = null;
          scheduler.startTimer = null;

          if (scheduler.stopped) {
            return;
          }

          scheduler.startTimer = null;
          scheduler.started = true;
          updatePrefetchState(scheduler);
          pumpPrefetchQueue(scheduler);
        };

        if ('requestIdleCallback' in window) {
          scheduler.idleCallbackId = window.requestIdleCallback(begin, { timeout: scheduler.startDelay });
        } else {
          scheduler.startTimer = window.setTimeout(begin, scheduler.startDelay);
        }
      };

      if (document.readyState === 'complete') {
        start();
      } else {
        scheduler.loadHandler = start;
        window.addEventListener('load', scheduler.loadHandler, { once: true });
      }
    };

    const replaceGroupContent = async (group, payload, direction, state, requestId, focusTarget, scrollPosition) => {
      const content = group.querySelector('[data-native-series-group-content]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const directionName = direction > 0 ? 'next' : 'previous';
      let shouldRestoreFocus = false;
      let shouldPreserveScroll = false;

      if (!content) {
        throw new Error('Series group content is missing');
      }

      clearTransitionClasses(content);

      if (!reducedMotion) {
        content.classList.add(`is-page-leaving-${directionName}`);
        await wait(transitionDuration);

        if (state.requestId !== requestId) {
          return false;
        }
      }

      shouldRestoreFocus = focusTarget && document.activeElement === focusTarget;
      shouldPreserveScroll = Math.abs(window.scrollX - scrollPosition.left) <= 4 && Math.abs(window.scrollY - scrollPosition.top) <= 4;
      content.innerHTML = payload.html;
      group.dataset.currentPage = String(payload.currentPage);
      initDynamicContent(content);

      if (shouldPreserveScroll) {
        restoreScroll(scrollPosition);
      }

      if (!reducedMotion) {
        clearTransitionClasses(content);
        content.classList.add(`is-page-entering-${directionName}`);
        void content.offsetWidth;
        group.setAttribute('aria-busy', 'false');
        await nextFrame();

        if (state.requestId !== requestId) {
          return false;
        }

        content.classList.remove(`is-page-entering-${directionName}`);
        await wait(transitionDuration);
      }

      if (state.requestId !== requestId) {
        return false;
      }

      const currentPageItem = content.querySelector('.chicchok-series-page-native__pagination-item.is-current');

      if (shouldRestoreFocus && currentPageItem) {
        currentPageItem.focus({ preventScroll: true });
      }

      if (shouldPreserveScroll) {
        restoreScroll(scrollPosition);
      }

      return true;
    };

    const loadGroupPage = async (section, group, targetPage, focusTarget) => {
      const currentPage = Number(group.dataset.currentPage || 1);

      if (!Number.isInteger(targetPage) || targetPage < 1 || targetPage === currentPage) {
        return;
      }

      const state = getGroupState(group);
      const requestId = state.requestId + 1;
      const cacheKey = getCacheKey(group, targetPage);
      const collectionTitle = group.querySelector('.chicchok-series-page-native__group-title a')?.textContent.trim() || '';
      const loadingLabel = section.dataset.paginationLoadingLabel || '';
      const errorLabel = section.dataset.paginationErrorLabel || '';
      const scrollPosition = {
        left: window.scrollX,
        top: window.scrollY
      };
      let didTimeout = false;
      let timeoutId = null;
      let resumePrefetch = null;

      state.requestId = requestId;
      const scheduler = prefetchSchedulers.get(section);
      if (scheduler) {
        selectPrefetchGroup(scheduler, group, true);
      }

      if (state.controller) {
        state.controller.abort();
      }

      state.controller = null;
      clearTransitionClasses(group.querySelector('[data-native-series-group-content]'));
      group.setAttribute('aria-busy', 'true');
      setPaginationStatus(group, loadingLabel);

      try {
        let payload = getPagePayload(group, targetPage);

        if (!payload) {
          resumePrefetch = prioritizeUserRequest(section, group, targetPage);
        }

        if (!payload && pageRequests.has(cacheKey)) {
          const sharedRequest = pageRequests.get(cacheKey);
          sharedRequest.userConsumers += 1;
          try {
            payload = await sharedRequest.promise;
          } finally {
            sharedRequest.userConsumers -= 1;
          }
        }

        if (state.requestId !== requestId || !group.isConnected) {
          return;
        }

        if (!payload) {
          const controller = new AbortController();
          state.controller = controller;
          timeoutId = window.setTimeout(() => {
            didTimeout = true;
            controller.abort();
          }, requestTimeout);

          let response;

          try {
            response = await fetchWithTransientRetry(buildSectionRequestUrl(group, targetPage), {
              credentials: 'same-origin',
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              },
              priority: 'high',
              signal: controller.signal
            });
          } finally {
            window.clearTimeout(timeoutId);
            timeoutId = null;
          }

          if (!response.ok) {
            throw new Error(`Series group request failed with ${response.status}`);
          }

          payload = parseGroupPayload(await response.text(), group);
          if (Number(payload.currentPage) !== targetPage) {
            throw new Error('Unexpected series group page response');
          }
          storePagePayload(group, targetPage, payload);
        }

        if (state.requestId !== requestId) {
          return;
        }

        const didReplace = await replaceGroupContent(group, payload, targetPage > currentPage ? 1 : -1, state, requestId, focusTarget, scrollPosition);

        if (!didReplace || state.requestId !== requestId) {
          return;
        }

        const loadedLabel = (section.dataset.paginationLoadedLabel || '')
          .replace('__COLLECTION__', collectionTitle)
          .replace('__PAGE__', String(payload.currentPage));

        setPaginationStatus(group, loadedLabel);
        if (scheduler) {
          refreshDesiredPrefetch(scheduler);
        }
      } catch (error) {
        if ((error.name === 'AbortError' && !didTimeout) || state.requestId !== requestId) {
          return;
        }

        clearTransitionClasses(group.querySelector('[data-native-series-group-content]'));
        setPaginationStatus(group, errorLabel, true);
      } finally {
        if (timeoutId) {
          window.clearTimeout(timeoutId);
        }

        if (state.requestId === requestId) {
          state.controller = null;
          group.setAttribute('aria-busy', 'false');
        }

        if (resumePrefetch) {
          resumePrefetch();
        }
      }
    };

    const initSection = section => {
      if (section.dataset.nativeSeriesSectionReady === 'true') {
        return;
      }

      section.dataset.nativeSeriesSectionReady = 'true';
      section.querySelectorAll('[data-native-series-gallery]').forEach(initGallery);
      section.querySelectorAll('[data-native-series-group]').forEach(group => {
        const content = group.querySelector('[data-native-series-group-content]');

        if (content) {
          storePagePayload(group, 1, {
            currentPage: 1,
            html: content.innerHTML
          });
        }
      });

      section.addEventListener('click', event => {
        const pageLink = event.target.closest('[data-native-series-page]');

        if (pageLink) {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return;
          }

          const group = pageLink.closest('[data-native-series-group]');
          const targetPage = Number(pageLink.dataset.nativeSeriesPage);

          if (group) {
            event.preventDefault();
            event.stopPropagation();
            loadGroupPage(section, group, targetPage, pageLink);
          }

          return;
        }

        const previousButton = event.target.closest('[data-native-series-media-prev]');
        const nextButton = event.target.closest('[data-native-series-media-next]');
        const button = previousButton || nextButton;

        if (!button) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        const gallery = button.closest('[data-native-series-gallery]');

        if (gallery) {
          moveGallery(gallery, previousButton ? -1 : 1);
        }
      });

      requestAnimationFrame(() => {
        initReveal(section);
        initPagePrefetch(section);
      });
    };

    const cleanupSection = section => {
      const observer = sectionObservers.get(section);

      if (observer) {
        observer.disconnect();
        sectionObservers.delete(section);
      }

      const prefetchScheduler = prefetchSchedulers.get(section);

      if (prefetchScheduler) {
        prefetchScheduler.stopped = true;
        prefetchScheduler.cartWaitToken += 1;
        prefetchScheduler.observer?.disconnect();
        prefetchScheduler.cleanupListeners.forEach(remove => remove());

        if (prefetchScheduler.startTimer) {
          window.clearTimeout(prefetchScheduler.startTimer);
        }

        if (prefetchScheduler.idleCallbackId && 'cancelIdleCallback' in window) {
          window.cancelIdleCallback(prefetchScheduler.idleCallbackId);
        }

        if (prefetchScheduler.loadHandler) {
          window.removeEventListener('load', prefetchScheduler.loadHandler);
        }

        prefetchSchedulers.delete(section);
      }

      section.querySelectorAll('[data-native-series-group]').forEach(group => {
        const state = groupStates.get(group);

        if (state) {
          state.requestId += 1;

          if (state.controller) {
            state.controller.abort();
          }

          groupStates.delete(group);
        }
      });

      pageCache.clear();
      pageRequests.forEach(request => request.controller.abort());
      pageRequests.clear();
      delete section.dataset.nativeSeriesSectionReady;
    };

    const initSections = root => {
      root.querySelectorAll('[data-chicchok-series-native]').forEach(initSection);
    };

    const init = () => initSections(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', event => initSections(event.target));
    document.addEventListener('shopify:section:unload', event => {
      const section = event.target.matches?.('[data-chicchok-series-native]')
        ? event.target
        : event.target.querySelector('[data-chicchok-series-native]');

      if (section) {
        cleanupSection(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let gesture = null;
    let suppress = null;
    document.addEventListener('pointerdown', (event) => {
      const link = event.target.closest('.chicchok-banner-hotspot');
      gesture = link ? { link, x: event.clientX, y: event.clientY, id: event.pointerId } : null;
      suppress = null;
    }, { passive: true });
    document.addEventListener('pointermove', (event) => {
      if (gesture && gesture.id === event.pointerId &&
          Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 10) {
        suppress = { link: gesture.link, until: Date.now() + 1000 };
      }
    }, { passive: true });
    document.addEventListener('pointercancel', () => { gesture = null; }, { passive: true });
    document.addEventListener('pointerup', () => { gesture = null; }, { passive: true });
    document.addEventListener('click', (event) => {
      const link = event.target.closest('.chicchok-banner-hotspot');
      if (event.detail !== 0 && link && suppress && suppress.link === link && Date.now() < suppress.until) {
        event.preventDefault();
        event.stopPropagation();
      }
      suppress = null;
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
